import React from 'react'

import styled from '@emotion/styled'

export interface TabListProps {
  role?: 'tablist' | 'nav'
  children: React.ReactNode
}

const TabListContainer = styled.div`
  display: flex;

  & > *:not(:first-child) {
    margin-left: 1.5rem;
  }
`

const TabList: React.FC<TabListProps> = ({ role, children }) => {
  const inferredProps =
    role === 'nav'
      ? {
          as: 'nav' as const,
        }
      : {
          role: 'tablist',
        }

  return <TabListContainer {...inferredProps}>{children}</TabListContainer>
}

export default TabList
